<!--header for mobile-->
<div class="hide-gt-sm menu-block">
	<!-- <div class="menu-toggler">
		<button mat-icon-button>
			<mat-icon class="icon-size-32" (click)="sidenav.toggle()" svgIcon="menu"></mat-icon>
		</button>
	</div> -->
	<div class="logo text-left">
		<mat-icon *ngIf="isArrowVisible" class="icon-size-24 arrow-left" (click)="backBtnClick()" svgIcon="backArrow"></mat-icon>
		<mat-icon [routerLink]="''" class="icon text-center" svgIcon="logo-header"></mat-icon>
	</div>
	<div class="icons-block">
		<ul>
			<li class="text-center" (click)="showSearchBlock = true">
				<mat-icon class="icon-size-24" svgIcon="search-icon"></mat-icon>
			</li>
			<!-- <li class="text-center" [routerLink]="['/wishlist']">
				<mat-icon
					class="icon-size-24"
					svgIcon="heartIcon"
				></mat-icon>
			</li> -->
			<li class="text-center" [routerLink]="['/compare']">
				<mat-icon class="icon-size-24" svgIcon="compare"></mat-icon>
			</li>
			<li class="text-center" [routerLink]="['/box']">
				<mat-icon class="icon-size-24" svgIcon="cartIcon"></mat-icon>
			</li>
			<!-- <li class="text-center" *ngIf="!isUserLoggedIn" [routerLink]="['/login']">
				<mat-icon class="icon-size-24" svgIcon="userIcon"></mat-icon>
			</li> -->

			<!-- <li class="text-center profile-block" *ngIf="isUserLoggedIn">
				<mat-icon class="icon-size-24" svgIcon="userIcon"></mat-icon>
				<div class="options">
					<h4 [routerLink]="['/profile']">Profile</h4>
					<h4 [routerLink]="['/wishlist']">Wishlist</h4>
					<h4 [routerLink]="['/orders']">Orders</h4>
					<h4 [routerLink]="['/appointments']">Appointments</h4>
					<h4 [routerLink]="['/customJewellery']">CustomJewellery</h4>
					<h4 (click)="doLogout()">Logout</h4>
				</div>
			</li> -->
		</ul>
	</div>
</div>

<!--header for web-->
<div class="show-gt-sm menu-block">
	<div class="logo">
		<mat-icon [routerLink]="''" class="icon text-center" svgIcon="logo-header"></mat-icon>
	</div>
	<div class="nav-item">
		<app-nav-bar></app-nav-bar>
	</div>
	<div class="icons-block">
		<ul>
			<li class="text-center" *ngIf="displaySearchInput" (click)="showSearchPopUp = true">
				<mat-icon class="icon-size-18" svgIcon="search-icon"></mat-icon>
				<span style="font: weigth 700px;">Search</span>
			</li>
			<!-- <li class="text-center" [routerLink]="['/wishlist']">
				<mat-icon
					class="icon-size-18"
					svgIcon="heartIcon"
				></mat-icon>
				<span style="font: weigth 700px;">Wishlist</span>
			</li> -->
			<li class="text-center" [routerLink]="['/compare']">
				<mat-icon class="icon-size-18" svgIcon="compare"></mat-icon>
				<span>Compare</span>
			</li>
			<li class="text-center" [routerLink]="['/box']">
				<mat-icon class="icon-size-18" svgIcon="cartIcon"></mat-icon>
				<span>Cart</span>
			</li>
			<li class="text-center" *ngIf="!isUserLoggedIn" [routerLink]="['/login']">
				<mat-icon class="icon-size-18" svgIcon="userIcon"></mat-icon>
				<span>Login</span>
			</li>

			<li class="text-center profile-block" *ngIf="isUserLoggedIn">
				<mat-icon class="icon-size-18" svgIcon="userIcon"></mat-icon>
				<span>Profile</span>

				<div class="options">
					<h4 [routerLink]="['/profile']">Profile</h4>
					<h4 [routerLink]="['/wishlist']">Wishlist</h4>
					<h4 [routerLink]="['/orders']">Orders</h4>
					<h4 [routerLink]="['/appointments']">Appointments</h4>
					<h4 [routerLink]="['/customJewellery']">CustomJewellery</h4>
					<h4 (click)="doLogout()">Logout</h4>
				</div>
			</li>
		</ul>

		<div class="text-center search-popup" *ngIf="showSearchPopUp">
			<span class="title">Search</span>
			<span class="close" (click)="showSearchPopUp = false">x</span>
			<div>
				<app-input leftIcon="search-icon" [placeholder]="'Hi 👋, how can I help you ?'"
					[className]="'icon-size-16'" [value]="searchCriteria.searchText"
					(onChangeEvent)="searchCriteria.searchText = $event" (onEnterEvent)="doSearch()"></app-input>

				<app-select [values]="selectOptions" [selectedValue]="searchCriteria.searchSelect"
					(onValueChange)="searchCriteria.searchSelect = $event"></app-select>

				<button class="search-btn" (click)="doSearch()">Search</button>
			</div>
		</div>
	</div>
</div>

<app-nav-bar class="hide-gt-sm"></app-nav-bar>
<mat-sidenav-container>
	<!-- <mat-sidenav #sidenav>
		<mat-nav-list>
			<app-nav-bar class="hide-gt-sm"></app-nav-bar>
		</mat-nav-list>
	</mat-sidenav> -->
	<mat-sidenav-content>
		<div *ngIf="showSearchBlock && displaySearchInput" class="hide-gt-sm search-block text-center">
			<div class="input-block">
				<app-input leftIcon="search-icon" [placeholder]="'Hi 👋, how can I help you?'"
					[className]="'icon-size-16'" [value]="searchCriteria.searchText"
					(onChangeEvent)="searchCriteria.searchText = $event" (onEnterEvent)="doSearch()"></app-input>

				<app-select [style]="'white'" [values]="selectOptions" [selectedValue]="searchCriteria.searchSelect"
					(onValueChange)="searchCriteria.searchSelect = $event"></app-select>
			</div>

			<div class="btn-block">
				<button class="btn search-btn" (click)="doSearch()">Search</button>
				<button class="btn close-btn" (click)="showSearchBlock = false">Close</button>
			</div>
		</div>
		<router-outlet></router-outlet>
		<app-footer></app-footer>
		<app-footer-social-media-row></app-footer-social-media-row>
	</mat-sidenav-content>
</mat-sidenav-container>